/**
 * Toast notification utility.
 * Uses a module-level ref set by ToastProvider - callable from anywhere (e.g. Redux thunks).
 */

let toastRef = null;

export const setToastRef = ref => {
  toastRef = ref;
};

export const showToast = (message, options = {}) => {
  if (toastRef) {
    toastRef(message, options);
  }
};
